<!-- bradcam_area  -->
<div class="bradcam_area bradcam_bg_2" id="goToTop">
    <div class="container">
        <div class="row">
            <div class="col-xl-12">
                <div class="bradcam_text">
                    <h3 i18n="@@deleteAccountPageTitle">Account deletion</h3>
                </div>
            </div>
        </div>
    </div>
</div>
<!--/ bradcam_area  -->

<!-- delete_account_area_start  -->
<div class="about_area plus_padding da-area">
    <div class="container">

        <div class="row justify-content-center">
            <div class="col-xl-9 col-lg-10">

                <p class="da-app">{{ view.appLine }}</p>
                <p class="da-intro">{{ view.intro }}</p>

                <!-- Procédure — la partie que Google exige de voir en évidence -->
                <div class="da-card da-card--steps">
                    <div class="da-card__head">
                        <span class="da-icon">🗑️</span>
                        <h4 class="da-card__title">{{ view.stepsTitle }}</h4>
                    </div>
                    <ol class="da-steps">
                        <li *ngFor="let s of view.steps">{{ s }}</li>
                    </ol>
                    <a class="da-cta" [href]="mailtoLink">{{ view.mailCta }}</a>
                </div>

                <div class="da-card">
                    <div class="da-card__head">
                        <span class="da-icon">⏱️</span>
                        <h4 class="da-card__title">{{ view.delayTitle }}</h4>
                    </div>
                    <p class="da-card__body">{{ view.delayBody }}</p>
                </div>

                <div class="da-card">
                    <div class="da-card__head">
                        <span class="da-icon">✅</span>
                        <h4 class="da-card__title">{{ view.deletedTitle }}</h4>
                    </div>
                    <ul class="da-list">
                        <li *ngFor="let d of view.deleted">{{ d }}</li>
                    </ul>
                </div>

                <div class="da-card">
                    <div class="da-card__head">
                        <span class="da-icon">📦</span>
                        <h4 class="da-card__title">{{ view.keptTitle }}</h4>
                    </div>
                    <ul class="da-list">
                        <li *ngFor="let k of view.kept">{{ k }}</li>
                    </ul>
                    <p class="da-note">{{ view.keptNote }}</p>
                </div>

                <div class="da-card da-card--contact">
                    <div class="da-card__head">
                        <span class="da-icon">✉️</span>
                        <h4 class="da-card__title">{{ view.contactTitle }}</h4>
                    </div>
                    <p class="da-card__body">{{ view.contactBody }}</p>
                    <a class="da-cta" href="mailto:{{ view.contactEmail }}">{{ view.contactEmail }}</a>
                </div>

                <p class="da-updated">{{ view.lastUpdated }}</p>

            </div>
        </div>
    </div>
</div>
<!--/ delete_account_area  -->
